import VueUploadComponent from 'vue-upload-component'
import InputFile from 'vue-upload-component/src/InputFile.vue'

const SmartInputFile = {
  name: 'SmartInputFile',
  extends: InputFile,
  methods: {
    changeOriginal: InputFile.methods.change,
    change(...args) {
      this.$parent.$emit('before-input')
      setTimeout(() => this.changeOriginal(...args))
    },
  },
}

export default {
  name: 'SmartUpload',
  components: {
    InputFile: SmartInputFile,
  },
  extends: VueUploadComponent,
  methods: {
    // Override method technique from https://medium.com/@danielalvidrez/vue-override-vendor-methods-e43777a29f82
    onDropOriginal: VueUploadComponent.methods.onDrop,
    onDrop(...args) {
      this.$emit('before-input')
      return this.onDropOriginal(...args)
    },
    // TODO: In VueUploadComponent 3, 'inputOnChange' replaces 'change' in the InputFile sub-component
    // https://github.com/lian-yue/vue-upload-component/blob/master/src/FileUpload.vue
    // inputOnChangeOriginal: VueUploadComponent.methods.inputOnChange,
    // async inputOnChange(...args) {
    //   this.$emit('before-input')
    //   await new Promise(resolve => setTimeout(resolve))
    //   return this.inputOnChangeOriginal(...args)
    // },
    addInputFileOriginal: VueUploadComponent.methods.addInputFile,
    async addInputFile(...args) {
      const result = await this.addInputFileOriginal(...args)
      this.$emit('after-input', result?.length)
      return result
    },
    addDataTransferOriginal: VueUploadComponent.methods.addDataTransfer,
    async addDataTransfer(...args) {
      const result = await this.addDataTransferOriginal(...args)
      this.$emit('after-input', result?.length)
      return result
    },
  },
}
